var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6387_542",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6387_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20C3.95 20 3.47917 19.8042 3.0875 19.4125C2.69583 19.0208 2.5 18.55 2.5 18C2.5 17.45 2.69583 16.9792 3.0875 16.5875C3.47917 16.1958 3.95 16 4.5 16H16.5C17.05 16 17.5208 16.1958 17.9125 16.5875C18.3042 16.9792 18.5 17.45 18.5 18C18.5 18.55 18.3042 19.0208 17.9125 19.4125C17.5208 19.8042 17.05 20 16.5 20H4.5ZM6 12.5H7.0625L12.875 6.6875L12.3333 6.125L11.8125 5.625L6 11.4375V12.5ZM4.5 13.2483V11.125C4.5 11.0139 4.52083 10.9132 4.5625 10.8229C4.60417 10.7326 4.65972 10.6528 4.72917 10.5833L12.875 2.4375C13.0278 2.28472 13.1933 2.17361 13.3717 2.10417C13.5499 2.03472 13.7374 2 13.9342 2C14.1308 2 14.3194 2.03472 14.5 2.10417C14.6806 2.17361 14.8479 2.28431 15.0021 2.43625L16.0625 3.5C16.2153 3.65278 16.3264 3.81944 16.3958 4C16.4653 4.18056 16.5 4.37076 16.5 4.57063C16.5 4.75799 16.4656 4.94222 16.3969 5.12333C16.3281 5.30444 16.2188 5.47 16.069 5.62L7.91667 13.7708C7.84722 13.8403 7.76736 13.8958 7.67708 13.9375C7.58681 13.9792 7.48611 14 7.375 14H5.25167C5.03875 14 4.86021 13.928 4.71604 13.784C4.57201 13.6398 4.5 13.4613 4.5 13.2483ZM12.875 6.6875L12.3333 6.125L11.8125 5.625L12.875 6.6875Z",
    fill: "#438D40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.c7e79ed56dd50b90bc94ea5ea2ce9a56.svg";
export { ForwardRef as ReactComponent };